export default __webpack_public_path__ + "static/media/gsda_logo.9a1eb835.jpg";